import { SmartComponent } from "smart-component-js";

class SearchRecipeComponent extends SmartComponent {
  constructor(element, parentComponent, params) {
    super(element, parentComponent, params);
    this.element = element;
    this.searchButton = this.element.querySelector('.advanced-search-bar__button');
    this.advancedSearchInput = this.element.querySelector('.advanced-search-bar__input');
    this.init();
  }

  search() {
    const keyword = this.advancedSearchInput.value || '';
    window.location.href = `${GENERIC_TRANSLATIONS.recipeSearchLink}?keyword=${encodeURIComponent(keyword)}`;
  }

  init() {
    this.searchButton?.addEventListener('click', () => this.search());
    this.advancedSearchInput.addEventListener('keypress', (e) => {
      if (e.key !== 'Enter') return;
      this.search();
    });
  }
}

export default SearchRecipeComponent;
